import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Incontro } from "@/types/api";

export function useIncontroProssimo() {
  return useQuery({
    queryKey: ["incontro-prossimo"],
    // 204 No Content → apiFetch ritorna body `null` (HTTP ok, corpo vuoto).
    queryFn: () => apiFetch<Incontro | null>("/api/v1/incontri/prossimo"),
    staleTime: 60_000,
  });
}
